import Loading from "../Loading/Loading"

export default function DropDownMenuLoading() {
  return (
    <div className="my-8 min-w-3xs">
      <Loading delay={0} inline={true} />
    </div>
  )
}
